import { j as t } from "./jsx-runtime-C5mzlN2N.js";
import { _ as a } from "./index-CuBIgTKC.js";
import { Search as f, ShieldAlertIcon as y, AlertTriangleIcon as k, InfoIcon as i, LightbulbIcon as h } from "lucide-react";
import * as s from "react";
import { D as _, a as w } from "./Dialog-ByYz4ABw.js";
import { c as d } from "./cn-qaFjX9_3.js";
const m = s.forwardRef(({ className: o, ...r }, e) => /* @__PURE__ */ t.jsx(
  a,
  {
    ref: e,
    className: d(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      o
    ),
    ...r
  }
));
m.displayName = a.displayName;
const M = ({
  children: o,
  command: r,
  content: e,
  ...n
}) => /* @__PURE__ */ t.jsx(_, { ...n, children: /* @__PURE__ */ t.jsx(
  w,
  {
    ...e,
    className: d(
      "overflow-hidden p-0 shadow-lg top-[15vh] translate-y-[0%]",
      e == null ? void 0 : e.className
    ),
    "aria-describedby": void 0,
    children: /* @__PURE__ */ t.jsx(
      m,
      {
        ...r,
        className: d(
          "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
          r == null ? void 0 : r.className
        ),
        children: o
      }
    )
  }
) }), N = s.forwardRef(({ className: o, ...r }, e) => (
  // eslint-disable-next-line react/no-unknown-property
  /* @__PURE__ */ t.jsxs("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
    /* @__PURE__ */ t.jsx(f, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
    /* @__PURE__ */ t.jsx(
      a.Input,
      {
        ref: e,
        className: d(
          "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          o
        ),
        ...r
      }
    )
  ] })
));
N.displayName = a.Input.displayName;
const C = s.forwardRef(({ className: o, ...r }, e) => (
  // eslint-disable-next-line react/no-unknown-property
  /* @__PURE__ */ t.jsx("div", { className: "flex items-center", "cmdk-input-wrapper": "", children: /* @__PURE__ */ t.jsx(
    a.Input,
    {
      ref: e,
      className: d(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        o
      ),
      ...r
    }
  ) })
));
C.displayName = a.Input.displayName;
const v = s.forwardRef(({ className: o, ...r }, e) => /* @__PURE__ */ t.jsx(
  a.List,
  {
    ref: e,
    className: d("max-h-[300px] overflow-y-auto overflow-x-hidden", o),
    ...r
  }
));
v.displayName = a.List.displayName;
const I = s.forwardRef((o, r) => /* @__PURE__ */ t.jsx(
  a.Empty,
  {
    ref: r,
    className: "py-6 text-center text-sm",
    ...o
  }
));
I.displayName = a.Empty.displayName;
const j = s.forwardRef(({ className: o, ...r }, e) => /* @__PURE__ */ t.jsx(
  a.Group,
  {
    ref: e,
    className: d(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      o
    ),
    ...r
  }
));
j.displayName = a.Group.displayName;
const R = s.forwardRef(({ className: o, ...r }, e) => /* @__PURE__ */ t.jsx(
  a.Separator,
  {
    ref: e,
    className: d("-mx-1 h-px bg-border", o),
    ...r
  }
));
R.displayName = a.Separator.displayName;
const z = s.forwardRef(({ className: o, ...r }, e) => /* @__PURE__ */ t.jsx(
  a.Item,
  {
    ref: e,
    className: d(
      "relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      o
    ),
    ...r
  }
));
z.displayName = a.Item.displayName;
const S = {
  note: {
    border: "border-gray-300 dark:border-zinc-800",
    bg: "bg-gray-100 dark:bg-zinc-800/50",
    iconColor: "text-gray-600 dark:text-zinc-300",
    titleColor: "text-gray-600 dark:text-zinc-300",
    textColor: "text-gray-600 dark:text-zinc-300",
    Icon: i
  },
  tip: {
    border: "border-green-500 dark:border-green-800",
    bg: "bg-green-200/25 dark:bg-green-950/70",
    iconColor: "text-green-600 dark:text-green-200",
    titleColor: "text-green-700 dark:text-green-200",
    textColor: "text-green-600 dark:text-green-50",
    Icon: h
  },
  info: {
    border: "border-blue-400 dark:border-blue-900/60",
    bg: "bg-blue-50 dark:bg-blue-950/40",
    iconColor: "text-blue-400 dark:text-blue-200",
    titleColor: "text-blue-700 dark:text-blue-200",
    textColor: "text-blue-600 dark:text-blue-100",
    Icon: i
  },
  caution: {
    border: "border-yellow-400 dark:border-yellow-400/25",
    bg: "bg-yellow-100/60 dark:bg-yellow-400/10",
    iconColor: "text-yellow-500 dark:text-yellow-300",
    titleColor: "text-yellow-600 dark:text-yellow-300",
    textColor: "text-yellow-700 dark:text-yellow-200",
    Icon: k
  },
  danger: {
    border: "border-rose-400 dark:border-rose-800",
    bg: "bg-rose-50 dark:bg-rose-950/40",
    iconColor: "text-rose-400 dark:text-rose-300",
    titleColor: "text-rose-800 dark:text-rose-300",
    textColor: "text-rose-700 dark:text-rose-100",
    Icon: y
  }
}, T = ({
  type: o,
  children: r,
  title: e,
  className: n,
  icon: l = !0
}) => {
  const { border: c, bg: p, iconColor: x, titleColor: g, textColor: u, Icon: b } = S[o];
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: d(
        "not-prose rounded-md border p-4 text-md my-2",
        l && "grid grid-cols-[min-content_1fr] items-baseline grid-rows-[fit-content_1fr] gap-x-4 gap-y-2",
        !l && e && "flex flex-col gap-2",
        "[&_a]:underline [&_a]:decoration-current [&_a]:decoration-from-font [&_a]:underline-offset-4 hover:[&_a]:decoration-1",
        "[&_code]:!bg-gray-50 [&_code]:dark:!bg-gray-800 [&_code]:!border-none",
        "[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:ps-4 [&_ul>li]:ps-1 [&_ul>li]:my-1",
        l && e && "items-center",
        c,
        p,
        n
      ),
      children: [
        l && /* @__PURE__ */ t.jsx(
          b,
          {
            className: d(e ? "align-middle" : "translate-y-1", x),
            size: 20,
            "aria-hidden": "true"
          }
        ),
        e && /* @__PURE__ */ t.jsx("h3", { className: d("font-medium", g), children: e }),
        /* @__PURE__ */ t.jsx(
          "div",
          {
            className: d(
              l && "col-start-2",
              !e && l && "row-start-1",
              u
            ),
            children: r
          }
        )
      ]
    }
  );
};
export {
  v as C,
  j as a,
  z as b,
  M as c,
  N as d,
  I as e,
  T as f,
  m as g,
  C as h
};
//# sourceMappingURL=Callout-D3Ja4OPX.js.map
